import { query } from 'operations';
import { GeneralIds, ModelTypes, QueryParams } from 'types/types';

interface RequestProps<T> {
  type: ModelTypes;
  ids?: GeneralIds;
  queryParams?: QueryParams;
  set: {
    data: (data: T) => void;
    loading?: React.Dispatch<React.SetStateAction<boolean>>;
  };
}

export default function useLazyQuery<T>({
  type,
  ids,
  queryParams,
  set: { data: setData, loading: setLoading },
}: RequestProps<T>) {
  return function () {
    setLoading?.(true);
    query<T>({
      type,
      ids,
      queryParams,
    }).then(res => {
      setData(res.data);
      setLoading?.(false);
    });
  };
}
